let jobs = [...new Set(
[
  "fire fighters",
  "police officers",
  "software engineers",
  "web developers",
  "plumbers",
  "welders",
  "painters",
  "soldiers",
  "hair dressers",
  "mechanical engineers",
  "UX designers",
  "politicians",
  "activists",
  "social media stars",
  "high schoolers",
  "teachers",
  "college students",
  "microbiologists",
  "physicians",
  "secretaries",
  "basketball players",
  "triathletes",
  "mechanics",
  "advertisers",
  "recruiters",
  "nurses",
  "retirees",
  'farmers',
  'people learning to code',
  'conservation officers',
  'construction workers',
  'field workers',
  'horse trainers',
  'landscapers',
  'contractors',
  'renters',
  'land lords',
  'startup founders',
  'photographers',
  'the homeless',
  'refugees',
  `moms`,
  `dads`,
  `kindergarteners`,
  `middle schoolers`,
  `high schoolers`,
  `hunters`,
  `product managers`,
  `data scientists`,
  `evolutionary psychologists`,
  `angel investors`,
  `pharmacists`,
  `chefs`,
  `astronomers`,
  `dogs`,
  `cats`,
  `pregnant women`,
  `women`,
  `men`,
  `girls in STEM`,
  `vegetarians`,
  `social media managers`

  

  ]
)]

let actions = [
  "meet for lunch",
  "keep track of time",
  "set personal goals",
  "communicate better",
  'relax',
  'sleep better',
  'eat healthier',
  'learn new things',
  'save time',
  'pay bills',
  'build a portfolio',
  'be more efficient',
  `network`,
  `go outside more often`,
  `shop`,
  `start small businesses`,
  `make meals`,
  `study`,
  `find interesting articles`,
  `exercise`,
  `meet new friends`,
  `organize their workspace`,
  `find jobs`,
  `find useful tech`,
  `make money`,
  `take care of their pets`

]

let tech = [
  'drones',
  'an online platform',
  'blockchain',
  'web sockets',
  'smartphones',
  'instant messaging',
  'social media',
  'photography',
  'Web RTC',
  'an API',
  'the internet of things',
  'VR',
  'AR',
  'graphs',
  'the internet',
  'a Raspberry Pi',
  'encryption',
  'bitcoin',
  'chatbots',
  'geolocation',
  `an accelerometer`,
  `machine learning`,
  `SMS`,
  `a Twitter bot`,
  `an image recognition API`  
]

export {
  jobs,
  actions,
  tech,
}


// WEBPACK FOOTER //
// ./src/data/index.js